<template>
    <div class="table-responsive">
    <base-crud
            v-if="load"
            crudName="Diagramas de Rede"
            newText="Novo Diagrama de Rede"
            :table="table"
            :columns="columns"
            :options="options"
            :endPoint="endPoint"
            :enableAdd="true"
            :enableEdit="true"
            :enableDelete="true"
            :enableView="false"
            :dataForm="dataForm"
        >
        </base-crud>
    </div>
</template>

<script>
import BaseCrud from "../Base/BaseCrud";

export default {
    data: function () {
        return {
            table: "colorsTable",
            load: false,
            // pages: [],
            // url: '',
            columns: ["id", "description", 'erp_code', "actions"],
            tableData: ["id", "description", 'erp_code', "actions"],
            options: {
                sortable: ["id", "description", 'erp_code', "actions"],
                filterable: ["id", "description", 'erp_code'],
                filterByColumn: true,
                debounce: 1000,
                pagination: {chunk: 10, dropdown: false, nav: "scroll"},
                perPage: 10,
                perPageValues: [10, 25, 50, 100],
                headings: {
                    id: "ID",
                    description: "Diagrama de Rede",
                    erp_code: "Código ERP",
                    actions: "Ações",
                },
                templates: {},
                requestFunction: function (data) {
                    let requestData = {};

                    let query = this.$parent.$parent.query(data.query);
                    requestData.params = data;
                    requestData.params.query = "";
                    requestData.params.with = [];

                    return this.$http.get(this.url + "?" + query, requestData).catch(
                        function (e) {
                            this.dispatch("error", e);
                        }.bind(this)
                    );
                },
            },
            endPoint: "network-diagrams/",

            dataForm: {},
        };
    },
    components: {
        BaseCrud,
    },
    methods: {
        query: function (query) {
            let columns = {
                id: "id",
                description: "description",
                erp_code: "erp_code",
            };
            let filters = "";
            $.each(query, function (index, value) {
                filters += columns[index] + "=" + value + "&";
            });
            return filters;
        },
    },
    mounted() {
        setTimeout(() => {
            this.load = true;
        }, 100)
    }
};
</script>

<style scoped>
.VuePagination {
    text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/NetworkDiagram/Crud.vue